import { useMemo } from 'react';
import { AppInitializing } from '@/screens/Initializing';
import { useAppSelector } from '@/store';

export function AppInitializedGuard(props: ChildrenProps) {
  const appState = useAppSelector(state => state.appState);
  const appInitialized = useMemo(() => appState.initialized, [appState.initialized]);

  if (!appInitialized) return <AppInitializing />;

  return props.children;
}